module.exports = __webpack_public_path__ + "img/一体柜.4ed6528a.png";